import styles from '../../styles'
import { ContainerItem } from '../../types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface DetailsProps {
    containerItem: ContainerItem
    compact: boolean
}

const Details: FC<DetailsProps> = ({ containerItem, compact }) => {
    const { t } = useTranslation()
    const quantityUnit = t('common.overview.quantityUnit')
    const quantityLabel = `${containerItem.quantity} ${quantityUnit}`
    const unitPriceLabel = `(${containerItem.unitPrice})`
    const primaryTextSize = compact ? 'normal' : 'large'

    return (
        <View style={styles.details}>
            <View style={[styles.header, compact && styles.headerCompact]}>
                <Typography.Description size={primaryTextSize} font="medium" style={styles.name}>
                    {containerItem.name} {unitPriceLabel}
                </Typography.Description>
                <View style={[styles.rightContent, compact && styles.rightContentCompact]}>
                    <Typography.Description
                        size={primaryTextSize}
                        font="medium"
                        style={styles.quantity}
                        numberOfLines={1}
                    >
                        {quantityLabel}
                    </Typography.Description>
                    <Typography.Description
                        size={primaryTextSize}
                        font="medium"
                        style={[styles.price, !compact && styles.priceExtended]}
                        numberOfLines={1}
                    >
                        {containerItem.price}
                    </Typography.Description>
                </View>
            </View>
        </View>
    )
}

export default Details
